import { toast } from 'react-toastify'; 
import axios from 'axios';
import API from '../../config/apiconfig';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userManagementApiLoader } from '../../action/loaderActions';
import { userLoginSuccess } from '../../action/userActions';

export const useResetPasswordOTPVerficationInstance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user);

  const forgetPasswordOTPVerfication = ({ email, otp }) => {
    dispatch(userManagementApiLoader({isUsermanagementLoader: true}));
    const data = {
      "email" : email,
      "otp" : otp
    };
      axios.post(
          `${API.USER_MANAGEMENT_API_BASE_URL}${API.RESET_PASSWORD_OTP_VERFICATION}`,
          data,
          {
              headers: {
                  'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
              },
          }
      )
      .then((response) => {
        toast.success(response?.data?.message, {
          autoClose: 6000,
        });
        console.log(response.data);
        dispatch(userLoginSuccess({...currentUser, isResetVerify: false}));
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
        navigate('/setpassword')
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || 'Error logging in!', {
          autoClose: 6000,
        });
        console.error('Error logging in:', error.response || error);
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      });
  };

  return { forgetPasswordOTPVerfication };
};
